<template>
  <div>
    <div class="section-header">
      Habit Programs
    </div>
    <div class="card card--white" >
      <div class="card--container">
        <div v-infinite-scroll="findThemes" infinite-scroll-disabled="busy" infinite-scroll-distance="15" v-if="themes.length > 0">
          <div v-for="theme in themes" :key="theme.id">
            <button :icon='true' :to="{name: 'themesDetail', params: {id: theme.id}}">
              <h-icon>edit</h-icon>
            </button>
            <router-link class="card-text-header" :to="{'name': 'themesDetail', params:{'id': theme.id}}">
              {{theme.name}}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginator from "@/services/api/paginator";
export default {
  data() {
    return {
      themes: [],
      busy: false
    };
  },
  created() {
    this.$eventHub.$emit("tutorial", "habitPrograms");
    this.start();
  },
  methods: {
    start() {
      this.themes = [];
      this.themePaginator = new Paginator(
        "CoachHabitPrograms",
        { deleted: false },
        { force: true }
      );
      this.findThemes();
    },
    findThemes() {
      if (this.themePaginator.finished) {
        return;
      }
      this.busy = true;
      this.themePaginator.next().then(results => {
        this.themes = [...this.themes, ...results];
        this.busy = false;
      });
    }
  }
};
</script>

<style>
</style>
